import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getFormSettings } from '../services/supabaseClient';

// Hook para verificar se um formulário está habilitado.
// Retorna { enabled, loading, error }.
// enabled é true por default (antes do carregamento e em caso de erro),
// para não bloquear acesso indevidamente quando a tabela/form_settings
// ainda não existe ou está inacessível.
export const useFormEnabled = (formId) => {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      setLoading(true);
      const { success, data, error: err } = await getFormSettings();
      if (cancelled) return;
      if (success) {
        // is_active !== false => habilitado (default true para ausentes)
        setEnabled(data[formId] !== false);
      } else {
        // Em erro, mantém habilitado (fallback seguro)
        setError(err);
        setEnabled(true);
      }
      setLoading(false);
    };
    check();
    return () => {
      cancelled = true;
    };
  }, [formId]);

  return { enabled, loading, error };
};

// Componente guard: envolve uma página de formulário e redireciona para
// /forms com mensagem se o formulário estiver desabilitado.
export const FormAccessGuard = ({ formId, formTitle, children }) => {
  const { enabled, loading } = useFormEnabled(formId);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!enabled) {
    return (
      <Navigate
        to="/forms"
        replace
        state={{
          formDisabled: `O formulário "${formTitle || formId}" está desabilitado no momento.`,
        }}
      />
    );
  }

  return children;
};
